export default __webpack_public_path__ + "static/media/comment-lock-o.1d392fec.svg";